export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13343.45ed6c2b.jpg";